import { openBlock as e, createElementBlock as t, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, c = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M8 2.25a.75.75 0 0 1 .75.75v1.25H14a.75.75 0 1 1 0 1.5h-1.876c-.513 2.56-1.507 4.914-2.91 6.96.367.24.735.445 1.093.606a.75.75 0 0 1-.614 1.368 9.54 9.54 0 0 1-1.38-.771 18.067 18.067 0 0 1-5.98 4.759.75.75 0 1 1-.667-1.344A16.57 16.57 0 0 0 7.122 13c-1.192-1.038-2.24-2.351-2.813-3.707a.75.75 0 1 1 1.382-.584c.454 1.074 1.312 2.18 2.332 3.086a17.265 17.265 0 0 0 2.57-6.044H2a.75.75 0 0 1 0-1.5h5.25V3A.75.75 0 0 1 8 2.25Zm7.957 7.283a1.25 1.25 0 0 1 1.087 0c.288.14.451.386.543.54.095.16.194.367.299.586l4.79 10.017a.75.75 0 1 1-1.353.648l-1.709-3.574h-6.228l-1.71 3.574a.75.75 0 1 1-1.353-.648l4.791-10.017c.105-.219.204-.426.3-.586.091-.154.254-.4.543-.54Zm-1.854 6.717h4.794l-2.352-4.917-.045-.095-.045.095-2.352 4.917Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  c
];
function n(r, d) {
  return e(), t("svg", o, [...a]);
}
const h = { render: n };
export {
  h as default,
  n as render
};
